import { requirePermission } from "@lib/permissions/guards";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute } from "@tanstack/react-router";
import { CalendarPlus } from "lucide-react";
import { AbsenceRequestForm } from "@/features/rh/conges/components/AbsenceRequestForm";
import { FORM_MODES } from "@/features/rh/conges/config/form.config";

export const Route = createFileRoute("/_app/rh/conges/demandes/new")({
  loader: requirePermission(PERMISSIONS.RH.CONGES.CREATE),
  staticData: {
    title: "Nouvelle demande de congés",
    icon: CalendarPlus,
    permission: PERMISSIONS.RH.CONGES.CREATE,
    section: "RH",
  },
  component: () => <AbsenceRequestForm mode={FORM_MODES.EMPLOYEE} />,
});
